import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { useTranslation } from "react-i18next";

export const AmbiguousCustomerDialog = ({
	visible,
	candidates,
	selectedId,
	onSelect,
	onCancel,
	onContinue,
	loading,
}) => {
	const { t } = useTranslation("common");

	return (
		<Dialog
			id="tier_dialog"
			className="tier_dialog"
			visible={visible}
			style={{ width: "360px" }}
			header={<span className="dialog_header">{t("invitation.choose_customer_header")}</span>}
			onHide={() => { if (!loading) onCancel(); }}
			closable={!loading}
			closeOnEscape={!loading}
			footer={(
				<div style={{ marginBottom: "1rem" }}>
					<Button
						icon="pi pi-times"
						onClick={onCancel}
						label={t("invitation.cancel_move")}
						className="p-button-text hideBtn"
						disabled={loading}
					/>
					<Button
						onClick={onContinue}
						loading={loading}
						disabled={!selectedId || loading}
						label={t("invitation.continue")}
						className="acceptBtn"
					/>
				</div>
			)}
			modal
			breakpoints={{ "960px": "75vw", "640px": "100vw" }}
		>
			<p className="choose-customer-info">{t("invitation.choose_customer_info")}</p>
			<div className="choose-customer-list" role="radiogroup">
				{(candidates || []).map((candidate) => {
					const inputId = `invite-candidate-${candidate.id}`;
					const isSelected = String(selectedId) === String(candidate.id);
					return (
						<label
							key={candidate.id}
							htmlFor={inputId}
							className={`choose-customer-item${isSelected ? " choose-customer-item-selected" : ""}`}
						>
							<RadioButton
								inputId={inputId}
								name="inviteBusinessCustomer"
								value={candidate.id}
								onChange={(e) => onSelect(e.value ?? candidate.id)}
								checked={isSelected}
							/>
							<span className="choose-customer-details">
								<span className="choose-customer-name">{candidate.name}</span>
								<span className="choose-customer-meta">
									{candidate.customerNum ? (
										<span>{t("business_customers.customer_num")}: {candidate.customerNum}</span>
									) : null}
									{candidate.segmentName ? (
										<span className="segment-tag-div">
											<span className="segment-class">{candidate.segmentName}</span>
										</span>
									) : null}
								</span>
							</span>
						</label>
					);
				})}
			</div>
		</Dialog>
	);
};
